import api from '../api';
import _ from 'lodash';
export const getLocations = () => async function ignoreThunk(dispatch) {
    api.get('/_api/locations').then((response) => {
        const payload = response.data.map((station) => {
            const orientation = station.orientation ? station.orientation : 'S';
            let anchor;
            switch (orientation) {
                case 'N':
                    anchor = { x: 0.5, y: 0 };
                    break;
                case 'NE':
                    anchor = { x: 1, y: 0 };
                    break;
                case 'E':
                    anchor = { x: 1, y: 0.5 };
                    break;
                case 'SE':
                    anchor = { x: 1, y: 1 };
                    break;
                case 'S':
                    anchor = { x: 0.5, y: 1 };
                    break;
                case 'SW':
                    anchor = { x: 0, y: 1 };
                    break;
                case 'W':
                    anchor = { x: 0, y: 0.5 };
                    break;
                case 'NW':
                    anchor = { x: 0, y: 0 };
                    break;
            }
            return {
                ...station,
                orientation,
                anchor,
            };
        });
        const normalisedLocations = _.keyBy(payload, 'id');
        dispatch({ type: 'GET_LOCATIONS_SUCCESS', payload: normalisedLocations });
    }, (error) => dispatch({ type: 'GET_LOCATIONS_ERROR', error }));
};
